import { AnalyticsLookerTokens, AnalyticsState } from '../reducers/analytics'
import { APIError } from '../types'

export enum AnalyticsActionTypes {
  GET_ANALYTICS = `[analytics] Fetch`,
  GET_ANALYTICS_SUCCESS = `[analytics] Fetch API_SUCCESS`,
  GET_ANALYTICS_ERROR = `[analytics] Fetch API_ERROR`,
  SET_ANALYTICS = `[analytics] Set`,
  ERROR_ANALYTICS = `[analytics] Error`,
  GET_LOOKER_TOKENS = `[analytics] Get Looker`,
  SET_LOOKER_TOKENS = `[analytics] Set Looker`,
}

interface GetAnalyticsAction {
  type: AnalyticsActionTypes.GET_ANALYTICS
  dashboardType: string
}

interface GetAnalyticsSuccessAction {
  type: AnalyticsActionTypes.GET_ANALYTICS_SUCCESS
  payload: AnalyticsState
}

interface GetAnalyticsErrorAction {
  type: AnalyticsActionTypes.GET_ANALYTICS_ERROR
  payload: APIError
}

export const getAnalytics = (dashboardType: string): GetAnalyticsAction => ({
  type: AnalyticsActionTypes.GET_ANALYTICS,
  dashboardType,
})

interface SetAnalyticsAction {
  type: AnalyticsActionTypes.SET_ANALYTICS
  payload: AnalyticsState
}

export const setAnalytics = (analytics: AnalyticsState): SetAnalyticsAction => ({
  type: AnalyticsActionTypes.SET_ANALYTICS,
  payload: analytics,
})

interface SetAnalyticsErrorAction {
  type: AnalyticsActionTypes.ERROR_ANALYTICS
  payload: APIError | null
}

export const setAnalyticsError = (error: APIError | null): SetAnalyticsErrorAction => ({
  type: AnalyticsActionTypes.ERROR_ANALYTICS,
  payload: error,
})

interface GetAnalyticsLookerTokensAction {
  type: AnalyticsActionTypes.GET_LOOKER_TOKENS
}

interface SetLookerTokensAction {
  type: AnalyticsActionTypes.SET_LOOKER_TOKENS
  payload: AnalyticsLookerTokens
}

export const setLookerTokens = (payload: AnalyticsLookerTokens): any => ({
  type: AnalyticsActionTypes.SET_LOOKER_TOKENS,
  payload: payload,
})

export type AnalyticsActions =
  | GetAnalyticsAction
  | GetAnalyticsSuccessAction
  | GetAnalyticsErrorAction
  | SetAnalyticsAction
  | SetAnalyticsErrorAction
  | GetAnalyticsLookerTokensAction
  | SetLookerTokensAction
